import { render } from "./AutoCallEditComponent.vue?vue&type=template&id=bffd0c1e&scoped=true"
import script from "./AutoCallEditComponent.vue?vue&type=script&lang=js"
export * from "./AutoCallEditComponent.vue?vue&type=script&lang=js"

import "./AutoCallEditComponent.vue?vue&type=style&index=0&id=bffd0c1e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffd0c1e"]])

export default __exports__